import { useEffect, useState } from 'react'
import { Button, Container, Wordmark, scrollToId } from './primitives'

export function Nav() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8)
    window.addEventListener('scroll', on, { passive: true })
    return () => window.removeEventListener('scroll', on)
  }, [])

  const closeAnd = (fn: () => void) => () => {
    setMenuOpen(false)
    fn()
  }

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: scrolled || menuOpen ? 'rgba(250,250,247,0.92)' : 'transparent',
        backdropFilter: scrolled || menuOpen ? 'saturate(1.4) blur(12px)' : 'none',
        WebkitBackdropFilter: scrolled || menuOpen ? 'saturate(1.4) blur(12px)' : 'none',
        borderBottom:
          scrolled || menuOpen ? '1px solid var(--line)' : '1px solid transparent',
        transition: 'background 200ms ease, border-color 200ms ease',
      }}
    >
      <Container
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 64,
          gap: 24,
        }}
      >
        <Wordmark />
        <div
          className="nav-links"
          style={{
            display: 'flex',
            gap: 28,
            fontSize: 14,
            color: 'var(--fg)',
            marginLeft: 'auto',
            marginRight: 24,
          }}
        >
          <a href="#work">Work</a>
          <a href="#pricing">Pricing</a>
          <a href="#faq">FAQ</a>
        </div>
        <Button
          variant="primary"
          className="nav-cta"
          onClick={() => scrollToId('pricing')}
        >
          Start your site <span style={{ opacity: 0.5 }}>→</span>
        </Button>
        <button
          type="button"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          className="nav-burger"
          onClick={() => setMenuOpen((v) => !v)}
          style={{
            display: 'none',
            width: 40,
            height: 40,
            alignItems: 'center',
            justifyContent: 'center',
            background: 'transparent',
            border: '1px solid var(--line-strong)',
            borderRadius: 2,
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <span
            aria-hidden
            style={{
              position: 'relative',
              width: 16,
              height: 10,
              display: 'inline-block',
            }}
          >
            <span
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                height: 1.5,
                background: 'var(--fg)',
                top: menuOpen ? 4 : 0,
                transform: menuOpen ? 'rotate(45deg)' : 'none',
                transition: 'transform 200ms ease, top 200ms ease, opacity 200ms ease',
              }}
            />
            <span
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                height: 1.5,
                background: 'var(--fg)',
                top: 4,
                opacity: menuOpen ? 0 : 1,
                transition: 'opacity 150ms ease',
              }}
            />
            <span
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                height: 1.5,
                background: 'var(--fg)',
                top: menuOpen ? 4 : 8,
                transform: menuOpen ? 'rotate(-45deg)' : 'none',
                transition: 'transform 200ms ease, top 200ms ease',
              }}
            />
          </span>
        </button>
      </Container>

      <div
        className="nav-drawer"
        style={{
          display: 'none',
          overflow: 'hidden',
          maxHeight: menuOpen ? 320 : 0,
          transition: 'max-height 240ms ease',
          borderTop: menuOpen ? '1px solid var(--line)' : '1px solid transparent',
        }}
      >
        <Container style={{ padding: '16px 32px 24px' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: 17,
              fontWeight: 500,
              letterSpacing: '-0.01em',
            }}
          >
            <a
              href="#work"
              onClick={closeAnd(() => scrollToId('work'))}
              style={{ padding: '14px 0', borderBottom: '1px solid var(--line)' }}
            >
              Work
            </a>
            <a
              href="#pricing"
              onClick={closeAnd(() => scrollToId('pricing'))}
              style={{ padding: '14px 0', borderBottom: '1px solid var(--line)' }}
            >
              Pricing
            </a>
            <a
              href="#faq"
              onClick={closeAnd(() => scrollToId('faq'))}
              style={{ padding: '14px 0' }}
            >
              FAQ
            </a>
          </div>
          <Button
            variant="primary"
            size="lg"
            onClick={closeAnd(() => scrollToId('pricing'))}
            style={{ width: '100%', justifyContent: 'center', marginTop: 16 }}
          >
            Start your site <span style={{ opacity: 0.5 }}>→</span>
          </Button>
        </Container>
      </div>
    </nav>
  )
}
